import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { map, findIndex, uniqBy, orderBy } from 'lodash';
const EVENT_GROUPING_THRESHOLD_IN_SECONDS = 100;

// Using "setup" style store, see: https://pinia.vuejs.org/core-concepts/#Setup-Stores
export const useTributeNotifications = defineStore('tributeNotifications', () => {
    // state
    const showNotificationsModal = ref(false);
    const notifications = ref([]);

    // actions/mutations
    function markAllAsRead() {
        notifications.value = map(notifications.value, (notif) => {
            notif.read = true;
            return notif;
        });
    }
    function markAsRead(notification) {
        const index = findIndex(notifications.value, { timestamp: notification.timestamp });
        notifications.value[index].read = true;
    }
    function addNotification({ event, slides, action, userName }) {
        const now = new Date();
        let notification = {
            action,
            grouping: Math.floor(now.valueOf() / EVENT_GROUPING_THRESHOLD_IN_SECONDS)
        };
        notification.uploadUserName = userName;
        
        const existingIndex = findIndex(notifications.value, notification);
        // Add the slides to an existing notification
        if (existingIndex > -1) {
            notifications.value[existingIndex].slides = uniqBy(notifications.value[existingIndex].slides.concat(slides), 'id');
            notifications.value[existingIndex].read = false;
            notifications.value[existingIndex].timestamp = now.toISOString();
        } else {
            notifications.value.push({ ...notification, slides: uniqBy(slides), read: false, timestamp: now.toISOString() });
        }

        if (!showNotificationsModal.value) {
            showNotificationsModal.value = true;
        }
    }
    function hide() {
        toggle(false);
    }
    function toggle(forcedState = null) {
        if (forcedState !== null) {
            showNotificationsModal.value = forcedState;
        } else {
            showNotificationsModal.value = !showNotificationsModal.value;
        }
    }
    function clearNotifications() {
        notifications.value = [];
    }

    // computed = getters
    const unreadNotifications = computed(() => {
        return notifications.value.filter(notif => !notif.read);
    })
    const hasUnreadNotifications = computed(() => {
        return unreadNotifications.value.length > 0;
    });
    const orderedNotifications = computed(() => {
        return orderBy(notifications.value, 'timestamp', 'desc');
    });
    return {
        // state
        showNotificationsModal,
        notifications,
        
        // actions
        markAllAsRead,
        markAsRead,
        addNotification,
        toggle,
        clearNotifications,
        hide,

        // getters
        unreadNotifications,
        hasUnreadNotifications,
        orderedNotifications,
    }
});